<app-back-header title="Photos of Canvassing" theme="grey50" back="/"></app-back-header>

<app-photo-gallery [photos]="imageData"></app-photo-gallery>